import Parse from 'parse'
const QuizAnswered = new Parse.Object.extend('QuizAnswered')

export default {
  select ({ state, commit, getters }, index) {
    if (!getters.isMatch(index)) {
      return
    }

    let payload = {
      number: index + 1,
      over: false
    }
    if (getters.selectedNumbers.length >= state.max) {
      payload.over = true
    }
    commit('setSelected', payload)
  },

  async submit ({ commit, getters, rootState }) {
    const answer = new QuizAnswered()
    answer.set('event', rootState.event.playing)
    answer.set('numbers', getters.selectedNumbers)
    const result = await answer.save()
    if (result) {
      commit('setSubmit', true)
    }
  },

  async checkSubmitted ({ commit, rootState }) {
    const result = await Parse.Cloud.run('submittedQuizAnswered', {
      eventId: rootState.event.playing.id
    })
    if (result) {
      commit('setSubmit', true)
    }
  }
}
